import React from "react";
import PropTypes from "prop-types";
import Media from "react-media";

const MediaQueryOverride = props => {
  const { children, query, overrideKey, ...restProps } = props;

  return (
    <Media query={query}>
      {matches =>
        matches
          ? React.cloneElement(children, {
              key: overrideKey,
              ...restProps
            })
          : children
      }
    </Media>
  );
};

MediaQueryOverride.propTypes = {
  query: PropTypes.string.isRequired
};

export default MediaQueryOverride;
